import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { NtfSumarioNotificacaoModel } from "../models/ntf-sumario-notificacao-model";
import { NtfMensagemConversaModel } from "../../dominio/ntf-mensagem-conversa-model";
import { NtfMensagemModel } from "../../dominio/ntf-mensagem-model";
import { NtfMensagemUsuarioModel } from "../../dominio/ntf-mensagem-usuario-model";
import { NtfMensagemCanalModel } from "../../dominio/ntf-mensagem-canal-model";
import { HubConnection } from "@microsoft/signalr";

@Injectable({
  providedIn: "root",
})
export class NotificacaoSignalr {
  private connection: HubConnection | null = null;

  public ntfSumarioNotificacaoSubject: BehaviorSubject<NtfSumarioNotificacaoModel | null>;
  public ntfMensagemSubject: BehaviorSubject<NtfMensagemModel | null>;
  public ntfMensagemConversaSubject: BehaviorSubject<NtfMensagemConversaModel | null>;
  public ntfMensagemUsuarioSubject: BehaviorSubject<NtfMensagemUsuarioModel | null>;
  public ntfMensagemCanalSubject: BehaviorSubject<NtfMensagemCanalModel | null>;

  constructor() {
    this.ntfSumarioNotificacaoSubject = new BehaviorSubject(null);
    this.ntfMensagemSubject = new BehaviorSubject(null);
    this.ntfMensagemConversaSubject = new BehaviorSubject(null);
    this.ntfMensagemUsuarioSubject = new BehaviorSubject(null);
    this.ntfMensagemCanalSubject = new BehaviorSubject(null);
  }

  start(connection: HubConnection) {
    this.reset();

    if (connection == null) {
      return;
    }

    this.connection = connection;

    this.connection.on('NtfSumarioNotificacao', (data) => {
      this.ntfSumarioNotificacaoSubject.next(data);
    });

    this.connection.on('NtfMensagem', (data) => {
      this.ntfMensagemSubject.next(data);
    });

    this.connection.on('NtfMensagemConversa', (data) => {
      this.ntfMensagemConversaSubject.next(data);
    });

    this.connection.on('NtfMensagemUsuario', (data) => {
      this.ntfMensagemUsuarioSubject.next(data);
    });

    this.connection.on('NtfMensagemCanal', (data) => {
      this.ntfMensagemCanalSubject.next(data);
    });

  }

  stop() {
    if (this.connection == null) {
      return;
    }

    this.connection.off('NtfSumarioNotificacao');
    this.connection.off('NtfMensagem');
    this.connection.off('NtfMensagemConversa');
    this.connection.off('NtfMensagemUsuario');
    this.connection.off('NtfMensagemCanal');
  }

  reset() {
    this.ntfSumarioNotificacaoSubject.next(null);
    this.ntfMensagemSubject.next(null);
    this.ntfMensagemConversaSubject.next(null);
    this.ntfMensagemUsuarioSubject.next(null);
    this.ntfMensagemCanalSubject.next(null);
  }
}
